module.exports = __webpack_public_path__ + "static/media/active_video_thumb5.27750fab.svg";